import React, { useState } from "react";
import { http } from "../lib/api";
import { toast } from "sonner";
import { Mail, Sparkles } from "lucide-react";

export default function InterestForm({ product, compact = false, onDone }) {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      await http.post("/interest", { email, product_id: product.id, product_name: product.name });
      setDone(true);
      toast.success("You're on the list — exclusive offer heading your way");
      onDone && onDone();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Something went wrong");
    }
    setBusy(false);
  };

  if (done) {
    return (
      <div className="oh-badge oh-badge-lime inline-flex items-center gap-2" data-testid={`interest-done-${product.slug}`}>
        <Sparkles size={12}/> On the list · exclusive offer inbound
      </div>
    );
  }

  if (compact) {
    return (
      <form onSubmit={submit} className="flex gap-2 w-full" data-testid={`interest-compact-${product.slug}`}>
        <input required type="email" placeholder="your@email.com"
          value={email} onChange={(e) => setEmail(e.target.value)}
          className="oh-input !py-2 !text-xs flex-1"
          data-testid={`interest-email-${product.slug}`}/>
        <button disabled={busy}
          className="oh-btn-lime px-3 py-2 rounded-full text-[10px] tracking-widest uppercase disabled:opacity-50 whitespace-nowrap"
          data-testid={`interest-submit-${product.slug}`}>
          {busy ? "…" : "Notify Me"}
        </button>
      </form>
    );
  }

  return (
    <form onSubmit={submit} className="space-y-3" data-testid={`interest-full-${product.slug}`}>
      <div className="flex items-center gap-2 text-xs font-mono text-lime-400 tracking-widest uppercase">
        <Mail size={14}/> Register Your Interest
      </div>
      <p className="text-sm text-white/70">
        This product is <b>coming soon</b>. Drop your email and Organic Healing will send you an <b>exclusive early-access offer</b> the moment it launches.
      </p>
      <div className="flex gap-2 flex-col sm:flex-row">
        <input required type="email" placeholder="your@email.com"
          value={email} onChange={(e) => setEmail(e.target.value)}
          className="oh-input flex-1"
          data-testid={`interest-email-${product.slug}`}/>
        <button disabled={busy}
          className="oh-btn-lime px-6 py-2.5 rounded-full text-xs tracking-widest uppercase disabled:opacity-50 whitespace-nowrap"
          data-testid={`interest-submit-${product.slug}`}>
          {busy ? "Adding…" : "Notify Me"}
        </button>
      </div>
      <p className="text-[11px] text-white/40">No spam. One email at launch with your exclusive offer.</p>
    </form>
  );
}
